export const getTimeBeforeShowLabel = (days: number) => {
  const absDays = Math.abs(days);

  if (days > 13) {
    return RESX.DateTime.XWeeksAfterShow.replace("{0}", Math.floor(absDays / 7).toString());
  }

  if (days > 3) {
    return RESX.DateTime.XDaysAfterShow.replace("{0}", absDays.toString());
  }

  if (days > 0) {
    return RESX.DateTime.XHoursAfterShow.replace("{0}", (absDays * 24).toString());
  }

  if (days === 0) {
    return RESX.DateTime.OnShowDate;
  }

  if (days >= -3) {
    return RESX.DateTime.XHoursBeforeShow.replace("{0}", (absDays * 24).toString());
  }

  if (days >= -13) {
    return RESX.DateTime.XDaysBeforeShow.replace("{0}", absDays.toString());
  }

  return RESX.DateTime.XWeeksBeforeShow.replace("{0}", Math.floor(absDays / 7).toString());
};

export const formatDeadline = (type: server.dto.UserTaskDeadlineTypes, days: number): string => {
  if (type === "relativeToShowDate") {
    return getTimeBeforeShowLabel(days);
  }

  if (days === 0) {
    return RESX.Task.OnTaskCreation;
  }

  return days === 1 ? RESX.DateTime.YDay : `${days} ${RESX.DateTime.days}`;
}